module.exports = __webpack_public_path__ + "img/xrpintel-waterfall.0e8bdc7f.gif";